import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditLead = ({ show, onClose, selectedId, refresh }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [leadTypeOptions, setLeadTypeOptions] = useState([]);
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);

    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/getleadtype`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.leadtype_name,
                }));
                setLeadTypeOptions(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/getleadsource`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.leadsource_name,
                }));
                setLeadSourceOptions(formattedsource);
            } catch (error) {
                console.log('Error fetching lead source:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [lead_name, setname] = useState('');
    const [mobile_no, setMobileno] = useState('');
    const [email_id, setEmailid] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [address, setAddress] = useState('');
    const [description, setdescription] = useState('');
    const [lead_type, setLeadtype] = useState('');
    const [lead_source, setLeadsource] = useState(null);
    const [selectedLeadType, setSelectedLeadType] = useState(null);
    const [selectedLeadSource, setSelectedLeadSource] = useState(null);
    const [product, setSelectedProducts] = useState('');
    const [selectedArea, setSelectedArea] = useState([]);
    const [area, setArea] = useState(null);

    useEffect(() => {
        axios.get(`${baseURL}/managelead/${selectedId}`)
            .then(response => {
                setSelectedLeadSource({
                    value: response.data.lead_source,
                    label: response.data.lead_sources_name,
                });
                setname(response.data.lead_name);
                setMobileno(response.data.mobile_no.toString());
                if (response.data.email_id) {
                    setEmailid(response.data.email_id);
                }
                if (response.data.latitude) {
                    setLatitude(response.data.latitude);
                }
                if (response.data.longitude) {
                    setLongitude(response.data.longitude);
                }
                if (response.data.address) {
                    setAddress(response.data.address);
                }
                if (response.data.description) {
                    setdescription(response.data.description);
                }
                setLeadtype(response.data.lead_type);
                setLeadsource(response.data.lead_source);
                setSelectedLeadType({
                    value: response.data.lead_type,
                    label: response.data.lead_type_name,
                });
                setSelectedProducts(response.data.product);
                setArea(response.data.area);
            })
            .catch(error => {
                console.log('There was an error fetching the posts!', error);
            });

    }, []);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const handleLeadTypeChange = (selectedOption) => {
        setSelectedLeadType(selectedOption); // for Select display
        setLeadtype(selectedOption.value);   // for storing sno
    };

    const handleLeadSourceChange = (selectedOption) => {
        setSelectedLeadSource(selectedOption);
        setLeadsource(selectedOption.value);
    };

    const [productoptions, setProductoption] = useState([]);
    const [selectedOptionsProd, setSelectedOptionsProd] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/manage-products/products/active`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.product_name,
                }));
                setProductoption(formatted);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const handleProductChange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
        setSelectedProducts(ids);
        setSelectedOptionsProd(selectedOptions);
    }

    useEffect(() => {
        if (product) {
            const selectedIds = product.split(',').map(id => parseInt(id));
            // console.log(selectedIds);
            const preselected = productoptions.filter(option => selectedIds.includes(option.value));
            // console.log(preselected);
            setSelectedOptionsProd(preselected);
        }
    }, [product, productoptions]);


    const [areaOption, setAreaOption] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, { params: { branch_id: branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.area_name,
                }));
                setAreaOption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        if (area) {
            const preselected = areaOption.filter(option => option.value === area);
            // console.log(preselected);
            setSelectedArea(preselected);
        }
    }, [area, areaOption]);

    const handleareachange = (selectedOption) => {
        setSelectedArea(selectedOption);
        setArea(selectedOption.value);
    };

    const [data_name, setData] = useState([]);
    const [data_mobile, setMob] = useState([]);
    const [data_email, setem] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/managelead/all_lead`)
            .then(response => {
                setData(response.data.data.filter(item => item.id !== selectedId).map(mode => mode.lead_name?.toLowerCase()));
                setMob(response.data.data.filter(item => item.id !== selectedId).map(mode => mode.mobile_no));
                setem(response.data.data.filter(item => item.id !== selectedId).map(em => em.email_id?.toLowerCase()).filter(email => email));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, [])

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;
        if (!lead_name.trim()) {
            newErrors.name = "This Field is Required.";
            // return newErrors;
        } else if (!regex.test(lead_name)) {
            newErrors.name = "Not a Valid Name";
            // return newErrors;
        } 
        // else if (data_name.includes(lead_name.trim().toLowerCase())) {
        //     newErrors.name = "This Name Already Exists";
        //     // return newErrors;
        // }

        if (!mobile_no) {
            newErrors.mobile = "This Field is Required.";
        } else if (data_mobile.some(num => num.toString() === mobile_no.trim())) {
            newErrors.mobile = "This Number Already Exists.";
        } else if (mobile_no.length < 10) {
            newErrors.mobile = "Enter a Valid Number.";
        } else if (!/^[6-9]\d{9}$/.test(mobile_no)) {
            newErrors.mobile = "Enter a Valid Number.";
        }

        if (email_id && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_id))) {
            newErrors.email = "Invalid Email.";
        }

        if (email_id && data_email.includes(email_id.trim().toLocaleLowerCase())) {
            newErrors.email = "This Email Already Exists.";
        }

        if (!area) {
            newErrors.area = "This Field is Required.";
        }

        if (!lead_type) {
            newErrors.type = "This Field is Required.";
        }

        if (!lead_source) {
            newErrors.source = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { lead_name, mobile_no, email_id, latitude, longitude, address, description, lead_type, lead_source, product, area, updated_by: user_id };
        // Create a new post
        axios.put(`${baseURL}/managelead/${selectedId}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Lead Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Lead Updation Failed");
            });
    };

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Lead</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/* <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Lead Type <span className="required">*</span></label>
                                <Select  placeholder="Select Lead Type"
                                    value={selectedLeadType}
                                    onChange={handleLeadTypeChange}
                                    options={leadTypeOptions}
                                />
                                {errors.type && <div className="text-danger fs-8 mt-1">{errors.type}</div>}
                            </div> */}
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Lead Name<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Lead Name"
                                    maxLength={100}
                                    value={lead_name}
                                    onChange={(e) => {
                                        const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                        setname(formatName(onlyAlphabets))
                                    }}
                                />
                                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Mobile No"
                                    maxLength={10}
                                    value={mobile_no}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setMobileno(onlyNums)
                                    }}
                                />
                                {errors.mobile && <div className="text-danger fs-8 mt-1">{errors.mobile}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Email ID</label>
                                <input type="text" className="form-control" placeholder="Enter Email ID"
                                    maxLength={100}
                                    value={email_id}
                                    onChange={(e) => setEmailid(e.target.value)}
                                />
                                {errors.email && <div className="text-danger fs-8 mt-1">{errors.email}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Area <span className="required">*</span></label>
                                <Select
                                    value={selectedArea}
                                    onChange={handleareachange}
                                    options={areaOption}
                                    placeholder="Select Area"
                                />
                                {errors.area && <div className="text-danger fs-8 mt-1">{errors.area}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Lead Source <span className="required">*</span></label>
                                <Select placeholder="Select Lead Source"
                                    value={selectedLeadSource}
                                    onChange={handleLeadSourceChange}
                                    options={leadSourceOptions}
                                />
                                {errors.source && <div className="text-danger fs-8 mt-1">{errors.source}</div>}
                            </div>


                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Product</label>
                                <Select placeholder="Select Product" isMulti
                                    options={productoptions}
                                    onChange={handleProductChange}
                                    value={selectedOptionsProd}
                                />
                            </div>
                            {/*<div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Latitude</label>
                                <input type="text" className="form-control" placeholder="Enter Latitude"
                                    maxLength={20}
                                    value={latitude} 
                                    onChange={(e) => setLatitude(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Longitude</label>
                                <input type="text" className="form-control" placeholder="Enter Longitude"
                                    maxLength={20}
                                    value={longitude} 
                                    onChange={(e) => setLongitude(e.target.value)}
                                />
                            </div>*/}
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Address</label>
                                <textarea className="form-control h-auto" name="comment" placeholder="Enter Address"
                                    maxLength={255}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea className="form-control h-auto" name="comment" placeholder="Enter Description"
                                    maxLength={255}
                                    value={description}
                                    onChange={(e) => setdescription(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary" >Update Lead <i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditLead;
